'use client'

import { useActionState } from 'react'

import { CheckCircle2Icon } from 'lucide-react'

import { sendContactMessage, type ContactState } from '@/app/actions/contact'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { useDictionary } from '@/lib/i18n/provider'

const INITIAL: ContactState = { status: 'idle' }

/**
 * Холбоо барих маягт.
 *
 * ⚠️ Өмнө нь загварын англи маягт байсан («Name / Email / Services →
 * Website Design…») бөгөөд `preventDefault()` хийгээд ХААШАА Ч илгээдэггүй
 * байв. Одоо server action-оор cloud руу очиж, «Вэбсайт → Холбоо барих
 * хүсэлт» хэсэгт бүртгэгдэнэ.
 */
const ContactForm = () => {
  const t = useDictionary()
  const [state, action, pending] = useActionState(sendContactMessage, INITIAL)

  if (state.status === 'ok') {
    return (
      <div className='flex flex-col items-center gap-4 rounded-2xl border border-dashed p-12 text-center'>
        <CheckCircle2Icon className='size-10 text-emerald-600 dark:text-emerald-400' />
        <p className='text-xl font-medium'>{t.contact.thanks}</p>
        <p className='text-muted-foreground text-xl text-pretty'>{state.message}</p>
      </div>
    )
  }

  return (

    /* Талбарын өндөр нь анкетын маягттай ижил — 32px хэт жижиг байв */
    <form
      action={action}
      className='space-y-6 [&_input:not([type=file]):not([type=checkbox])]:h-11 [&_textarea]:text-base'
    >
      <div className='grid gap-6 sm:grid-cols-2'>
        <div className='space-y-2'>
          <Label htmlFor='name'>{t.contact.name} *</Label>
          <Input id='name' name='name' required maxLength={120} placeholder={t.contact.namePlaceholder} />
        </div>

        <div className='space-y-2'>
          <Label htmlFor='company'>{t.contact.company}</Label>
          <Input id='company' name='company' maxLength={160} placeholder={t.contact.companyPlaceholder} />
        </div>

        <div className='space-y-2'>
          <Label htmlFor='email'>{t.contact.email}</Label>
          <Input id='email' name='email' type='email' maxLength={120} placeholder='name@example.com' />
        </div>

        <div className='space-y-2'>
          <Label htmlFor='phone'>{t.contact.phone}</Label>
          <Input id='phone' name='phone' maxLength={40} placeholder='9911-1111' />
        </div>
      </div>

      <div className='space-y-2'>
        <Label htmlFor='subject'>{t.contact.subject}</Label>
        <Input id='subject' name='subject' maxLength={160} placeholder={t.contact.subjectPlaceholder} />
      </div>

      <div className='space-y-2'>
        <Label htmlFor='message'>{t.contact.message} *</Label>
        <Textarea id='message' name='message' required maxLength={4000} className='h-28 resize-none' />
      </div>

      {/* Далд талбар — зөвхөн бот бөглөнө. Дэлгэц уншигчаас ч нуугдана. */}
      <input type='text' name='website' tabIndex={-1} autoComplete='off' aria-hidden className='hidden' />

      <p className='text-muted-foreground text-xl'>{t.contact.reachHint}</p>

      {state.status === 'error' && (
        <p className='text-destructive text-xl' role='alert'>
          {state.message}
        </p>
      )}

      <Button type='submit' className='w-full' size='lg' disabled={pending}>
        {pending ? t.contact.sending : t.contact.submit}
      </Button>
    </form>
  )
}

export default ContactForm
